import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { LuFileDown, LuSheet } from 'react-icons/lu';
import { invoiceNumberCorrelativo } from './invoiceNumberUtils';

const EMPRESA_PTB = 1;

function DocDownloadRow({
  labelPdf,
  labelExcel,
  disabled,
  title,
  busy,
  downloadingPdf,
  downloadingExcel,
  onPdf,
  onExcel,
}) {
  const tip = title || undefined;
  return (
    <span
      className="d-block"
      title={tip}
      style={disabled ? { cursor: 'not-allowed' } : undefined}
    >
      <div className="d-flex gap-2">
        <Button
          type="button"
          variant="outline-primary"
          className="d-flex align-items-center justify-content-center gap-2 flex-grow-1"
          disabled={disabled || busy}
          style={disabled ? { pointerEvents: 'none' } : undefined}
          onClick={() => !disabled && onPdf()}
        >
          <LuFileDown />
          {downloadingPdf ? 'Generando…' : labelPdf}
        </Button>
        <Button
          type="button"
          variant="outline-success"
          className="d-flex align-items-center justify-content-center gap-2 flex-grow-1"
          disabled={disabled || busy}
          style={disabled ? { pointerEvents: 'none' } : undefined}
          onClick={() => !disabled && onExcel()}
        >
          <LuSheet />
          {downloadingExcel ? 'Generando…' : labelExcel}
        </Button>
      </div>
    </span>
  );
}

const InvoiceDescargasModal = ({
  show,
  row,
  onClose,
  onDownloadPackingList,
  onDownloadPackingListExcel,
  onDownloadPkDecla,
  onDownloadPkDeclaExcel,
  onDownloadGradeHeight,
  onDownloadGradeHeightExcel,
  onDownloadHt,
  onDownloadHtExcel,
  onDownloadInvoicePtc,
  onDownloadInvoicePtcExcel,
  onDownloadInvoicePtb,
  onDownloadInvoicePtbExcel,
  downloadingPl,
  downloadingPlExcel,
  downloadingPkDecla,
  downloadingPkDeclaExcel,
  downloadingGradeHeight,
  downloadingGradeHeightExcel,
  downloadingHt,
  downloadingHtExcel,
  downloadingPtc,
  downloadingPtcExcel,
  downloadingPtb,
  downloadingPtbExcel,
}) => {
  const esEmisorPtb = row?.empresa_emisor === EMPRESA_PTB;
  const busy =
    downloadingPl ||
    downloadingPlExcel ||
    downloadingPkDecla ||
    downloadingPkDeclaExcel ||
    downloadingGradeHeight ||
    downloadingGradeHeightExcel ||
    downloadingHt ||
    downloadingHtExcel ||
    downloadingPtc ||
    downloadingPtcExcel ||
    downloadingPtb ||
    downloadingPtbExcel;
  const sinInvoice = !row?.tiene_invoice;
  const invoiceDisabled = sinInvoice || !row?.id_invoice;

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Descargar documentos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small">
          {row?.tiene_invoice
            ? `Invoice ${invoiceNumberCorrelativo(row?.numero_invoice)} — Booking ${row?.nro_booking}`
            : `Booking ${row?.nro_booking} — sin invoice`}
        </p>
        <div className="d-flex flex-column gap-2">
          {!esEmisorPtb ? (
            <DocDownloadRow
              labelPdf="Invoice PTC (PDF)"
              labelExcel="Invoice PTC (Excel)"
              disabled={invoiceDisabled}
              title={sinInvoice ? 'Se debe crear prefactura' : undefined}
              busy={busy}
              downloadingPdf={downloadingPtc}
              downloadingExcel={downloadingPtcExcel}
              onPdf={() => onDownloadInvoicePtc(row)}
              onExcel={() => onDownloadInvoicePtcExcel(row)}
            />
          ) : null}
          <DocDownloadRow
            labelPdf="Invoice PTB (PDF)"
            labelExcel="Invoice PTB (Excel)"
            disabled={invoiceDisabled}
            title={sinInvoice ? 'Se debe crear prefactura' : undefined}
            busy={busy}
            downloadingPdf={downloadingPtb}
            downloadingExcel={downloadingPtbExcel}
            onPdf={() => onDownloadInvoicePtb(row)}
            onExcel={() => onDownloadInvoicePtbExcel(row)}
          />
          <DocDownloadRow
            labelPdf="Packing List (PDF)"
            labelExcel="Packing List (Excel)"
            disabled={!row?.id_packing_list}
            busy={busy}
            downloadingPdf={downloadingPl}
            downloadingExcel={downloadingPlExcel}
            onPdf={() => onDownloadPackingList(row)}
            onExcel={() => onDownloadPackingListExcel(row)}
          />
          <DocDownloadRow
            labelPdf="PK Decla (PDF)"
            labelExcel="PK Decla (Excel)"
            disabled={!row?.id_packing_list}
            busy={busy}
            downloadingPdf={downloadingPkDecla}
            downloadingExcel={downloadingPkDeclaExcel}
            onPdf={() => onDownloadPkDecla(row)}
            onExcel={() => onDownloadPkDeclaExcel(row)}
          />
          <DocDownloadRow
            labelPdf="Grade Height (PDF)"
            labelExcel="Grade Height (Excel)"
            disabled={!row?.id_packing_list}
            busy={busy}
            downloadingPdf={downloadingGradeHeight}
            downloadingExcel={downloadingGradeHeightExcel}
            onPdf={() => onDownloadGradeHeight(row)}
            onExcel={() => onDownloadGradeHeightExcel(row)}
          />
          <DocDownloadRow
            labelPdf="HT (PDF)"
            labelExcel="HT (Excel)"
            disabled={!row?.id_packing_list || invoiceDisabled}
            title={
              sinInvoice
                ? 'Se debe crear prefactura'
                : !row?.id_packing_list
                  ? 'Se requiere packing list'
                  : undefined
            }
            busy={busy}
            downloadingPdf={downloadingHt}
            downloadingExcel={downloadingHtExcel}
            onPdf={() => onDownloadHt(row)}
            onExcel={() => onDownloadHtExcel(row)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvoiceDescargasModal;
